export default [
  {
    path: '/stage-milestones',
    component: () => import('./views/Index'),
    name: 'arena-milestone',
    redirect: { name: 'arena-milestone-list' },
    children: [
      {
        path: '',
        name: 'arena-milestone-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'content',
          navActiveLink: 'stage_level',
        },
      },
      {
        path: ':milestone_id',
        name: 'arena-milestone-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'content',
          navActiveLink: 'stage_level',
        },
      },
    ],
  },
]
